import { render, staticRenderFns } from "./ModalMoveContainer.vue?vue&type=template&id=2d596bd5"
import script from "./ModalMoveContainer.vue?vue&type=script&lang=js"
export * from "./ModalMoveContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports